<template>
  <div class="row d-flex justify-content-center">
    <div class="row col-12 px-3 mt-5 d-flex justify-content-center">
      <div class="col-12 pl-0 mx-auto text-center" v-if="showtext != false">
        <b>ASSINATURA:</b>
      </div>
      <img
        v-if="assinatura_print != '' && assinatura_print != null"
        :src="`${assinatura_print}?v${d.getTime()}`"
        class="mx-auto"
        style="width: 300px"
      />
    </div>
    <div class="col-auto max-auto" v-if="tecnico">
      <div class="col-12 d-flex justify-content-start" v-if="tecnico.nome">
        Nome Completo: <b class="ml-2">{{ tecnico.nome }}</b>
      </div>
      <div class="col-12 d-flex justify-content-start" v-if="tecnico.profissao">
        Cargo: <b class="ml-2">{{ tecnico.profissao }}</b>
      </div>
      <!-- <div
        class="col-12 d-flex justify-content-start"
        v-if="tecnico.conselho_profissional"
      >
        Conselho Profissional:
        <b class="ml-2">{{ tecnico.conselho_profissional }}</b>
      </div> -->
      <!-- <div
        class="col-12 d-flex justify-content-start"
        v-if="tecnico.numero_registro"
      >
        Número de Registro: <b class="ml-2">{{ tecnico.numero_registro }}</b>
      </div> -->
      <div
        class="col-12 d-flex justify-content-start"
        v-if="tecnico.email_user"
      >
        E-mail: <b class="ml-2">{{ tecnico.email_user }}</b>
      </div>
      <!-- <div
        class="col-12 d-flex justify-content-start"
        v-if="(tecnico.telefone || tecnico.whatsapp) && wpp"
      >
        Celular/Telefone: <b class="mx-2">{{ tecnico.telefone }}</b> Whatsapp:
        <b class="ml-2">{{ tecnico.whatsapp }}</b>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  props: ["assinatura", "showtext", "tecnico", "email", "wpp"],
  data() {
    return { assinatura_print: "", d: new Date() };
  },
  mounted() {
    if (this.assinatura) {
      this.assinatura_print = this.assinatura;
    } else {
      this.assinatura_print = null;
    }
  },
};
</script>
